import api from "!../../node_modules/style-loader/dist/runtime/injectStylesIntoStyleTag.js";
            import content from "!!../../node_modules/css-loader/dist/cjs.js!../../node_modules/redweb-template-library/media-query-plugin/loader.js!../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[0].use[3]!../../node_modules/sass-loader/dist/cjs.js??ruleSet[1].rules[0].use[4]!../../node_modules/mini-css-extract-plugin/dist/loader.js!../../node_modules/css-loader/dist/cjs.js!../../node_modules/redweb-template-library/media-query-plugin/loader.js!../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[5].use[3]!../../node_modules/sass-loader/dist/cjs.js??ruleSet[1].rules[5].use[4]!./app.scss";

var options = {};

options.insert = "head";
options.singleton = false;

var update = api(content, options);



export default content.locals || {};